module.exports = __webpack_public_path__ + "e-learning-app/static/img/school1.dfb39e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-area/img/ne/school1.png
// module id = u5JH
// module chunks = 1